/* @flow */

import { combineReducers } from 'redux';
import folders from './folders';
import uploads from './uploads';
import resources from './resources';
import type { FoldersState } from './folders';

export type State = {
  folders: FoldersState,
};

export default combineReducers({
  folders,
  uploads,
  resources,
});



// WEBPACK FOOTER //
// ./src/modules/bucket/reducers/index.js